import React from 'react';
import SVG from '../SVG';
const SortIcon = ({ className }) => React.createElement(SVG, { viewBox: "0 0 24 24", className: className },
    React.createElement("g", null,
        React.createElement("path", { d: "M0,0H11.8", transform: "translate(2.098 4.667)", fill: "none", stroke: "#505271", strokeLinecap: "round", strokeWidth: "1.5" }),
        React.createElement("path", { d: "M0,0H7.642", transform: "translate(4.179 8)", fill: "none", stroke: "#505271", strokeLinecap: "round", strokeWidth: "1.5" }),
        React.createElement("path", { d: "M0,0H2.8", transform: "translate(6.601 11.333)", fill: "none", stroke: "#505271", strokeLinecap: "round", strokeWidth: "1.5" }),
        React.createElement("path", { d: "M0,0H16V16H0Z", fill: "none", opacity: "0" })));
export default SortIcon;
//# sourceMappingURL=SortIcon.js.map